/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useState } from 'react';
import { Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { WORKBOARD_CURRENT_JOBS_URL } from 'dashboard409a/common/config/urls';
import OrganizationSelector from '../OrganizationSelector';
import useStyles from './styles';
import { IProductSelector } from './types';

const ProductSelector: FC<IProductSelector> = props => {
  const { permissions } = props;
  const navigate = useNavigate();
  const [appSelected, setAppSelected] = useState<'NONE' | 'PORTFOLIO_VALUATION' | 'DASHBOARD_409A'>('NONE');
  const [{ user }] = useStore() as unknown as UseStoreValues;

  const classes = useStyles();

  const continueToPortfolioValuation = () => setAppSelected('PORTFOLIO_VALUATION');
  const continueToDashboard409A = useCallback(() => {
    navigate(WORKBOARD_CURRENT_JOBS_URL);
  }, [user, navigate]);

  switch (appSelected) {
    case 'PORTFOLIO_VALUATION':
      return <OrganizationSelector lowerPermissions={permissions} />;

    case 'DASHBOARD_409A':
      return <OrganizationSelector lowerPermissions={permissions} isDashboard />;

    default:
      break;
  }

  return (
    <Paper className={classes.root}>
      <Typography variant="h2" className={classes.title}>
        Select Product
      </Typography>

      <>
        <Button variant="contained" fullWidth className={classes.button} onClick={continueToPortfolioValuation}>
          <p className={classes.buttonText}>Continue to Portfolio Valuation</p>
        </Button>

        <Typography component="p" variant="h3" className={classes.orText}>
          OR
        </Typography>

        <Button variant="contained" fullWidth className={classes.button} onClick={continueToDashboard409A}>
          <p className={classes.buttonText}>Continue to Company Valuations</p>
        </Button>
      </>
    </Paper>
  );
};

export default ProductSelector;
